import {
  OPEN_DIALOG,
  CLOSE_DIALOG,
} from './dialogs.actions';


export function dialogsReducer(state: IDialogsState, action: any) {
  switch (action.type) {
    case OPEN_DIALOG:
      return Object.assign({}, state, {
        isShowDialog: true,
        dialogOptions: action.dialogOptions
      })
    case CLOSE_DIALOG:
      return Object.assign({}, state, {
        isShowDialog: false,
        content: ''
      })
    default:
      return state;
  }
}

export interface IDialogsState {
  isShowDialog: boolean,
  content,
}
